import { push } from 'redux-first-history';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import ApiInstance from 'src/helpers/apiInstance';
import actions from './actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { t } from '../../../../../../i18n';

const priceListFormDataApi = new ApiInstance('companies/:id/skill_rate_groups/form_data');
const createPriceListFormDataApi = new ApiInstance('companies/:id/skill_rate_groups');

function* loadFormData({ payload }) {
  try {
    const { id } = payload;

    const result = yield call(
      sendRequest,
      priceListFormDataApi.get,
      { pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200 && result?.data?.positions?.length) {
      yield put(actions.loadFormDataSuccess(result.data));
    } else {
      const { messages } = result;

      if (messages) {
        yield put(actions.loadFormDataError({ errors: messages }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* createPriceList({ payload }) {
  try {
    const { data, id, isSubUnit } = payload;

    const urlPrefix = isSubUnit ? 'subUnits' : 'units';

    const result = yield call(
      sendRequest,
      createPriceListFormDataApi.post,
      { data, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.created_successfully', {
            item: t('dash.units.unit.priceList.add_new_pricelist.pricing_label'),
          }),
        }),
      );

      yield put(push(`/${urlPrefix}/${id}?tab[]=unitPriceList`));
    } else {
      yield put(actions.createPriceListError({ errors: result }));
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.talent.bull_form_request_modal.on_submit_error_message'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_FORM_DATA_REQUEST, loadFormData)]);
  yield all([takeEvery(actions.CREATE_PRICE_LIST_REQUEST, createPriceList)]);
}
